// extracted by mini-css-extract-plugin
var _1 = "AnnotationSheet-module__animateUploadProgressBarWidth--NpTIc";
var _2 = "AnnotationSheet-module__animatedBackground--gCL05";
var _3 = "AnnotationSheet-module__contextContainer--iQjK3";
var _4 = "AnnotationSheet-module__createContainer--aR_Nf";
var _5 = "AnnotationSheet-module__hasPreview--gGAjR";
var _6 = "AnnotationSheet-module__linkInputContainer--Z5bj3";
var _7 = "AnnotationSheet-module__previewContainer--hQS9z";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "contextContainer", _4 as "createContainer", _5 as "hasPreview", _6 as "linkInputContainer", _7 as "previewContainer" }
